import { FC, ReactElement } from 'react';

import { IKnowledgeAreaDetailsLayoutProps } from './knowledge-area-details-layout.interface';
import styles from './knowledge-area-details-layout.module.scss';

import { Card } from 'views/components/UI/Card';
import { Container } from 'views/components/UI/Container';

const KnowledgeAreaDetailsLayout: FC<IKnowledgeAreaDetailsLayoutProps> = (
  props,
): ReactElement => {
  const {
    levelsTitle,
    levelsPane,
    wrapLevelsPaneInCard = true,
    paddingBottom = '1.5rem',
    children,
  } = props;

  return (
    <div className={styles.layout__wrapper} style={{ paddingBottom }}>
      <Container>
        <div className={styles.layout__body}>
          {levelsPane && (
            <div className={styles['layout__levels-column']}>
              {levelsTitle}
              {wrapLevelsPaneInCard ? (
                <Card cardPadding="0" className={styles['layout__levels-card']}>
                  {levelsPane}
                </Card>
              ) : (
                levelsPane
              )}
            </div>
          )}
          <div className={styles.layout__exercises}>{children}</div>
        </div>
      </Container>
    </div>
  );
};

export { KnowledgeAreaDetailsLayout };
